import React,{useState} from 'react';
import CustomModal from './CustomModal';
import { useTranslation } from 'react-i18next';
import constants from '../../common/constants';

const About = (props) => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    
    const [showModal, setShowModal] = useState(false);
    const user_id = props.user_id;
    const operator = localStorage.getItem('currentOperator');
    const operatorDemos = ["DEMO","OOREDOO_ALGERIA"];
    const isOperator = operatorDemos.includes(operator);
    const hostnames = ['iq', 'ro', 'ae', 'zkw']
    const has_sign_button = hostnames.includes(props.hostname);

    const handleShowModal = () => {
        if(isOperator){
          setShowModal(true);
          document.body.classList.add('no-scroll');
        }
        if(constants.Operators[operator].Sub_link){
            window.location.href = constants.Operators[operator].Sub_link
        }
      };
  
      const handleCloseModal = () => {
        setShowModal(false);
        document.body.classList.remove('no-scroll'); // Enable scrolling
      };

    return (
        <div id="about" className='container about-div' style={{ backgroundPosition: "relative" }}>
            <div className='row'>
                <div className='col-md-6'>
    
                    {user_id ? (
                       <>
                        <div className={`about-title-1 ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} style={{ fontSize: "2em",paddingTop:"50px" }}>
                        {t('about.title')}
                        </div>
                        <p className={`about-desc pb-5 pt-4 w-50 ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{ fontSize: "1em",color:"#909090" }}>
                        {t('about.description')}
                        </p>
                      </>
                    ):(
                     <>
                        <div className={`about-title ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} style={{ fontSize: "2em" }}>
                        {t('about.title')}
                        </div>
                        <p className={`about-desc pt-4 ${isArabic ? 'notokufi-regular' : 'avenir-regular'} w-50`} style={{ fontSize: "0.9em",color:"#909090" }}>
                        {t('about.description')}
                        </p>
                        {!has_sign_button &&(
                            <button type="button" className={`btn btn-signin ${isArabic ? 'notokufi-bold' : 'avenir-heavy'} `} onClick={handleShowModal}>
                              {t('nav.sign_in')}
                            </button>
                        )}
                      </>
                    )}
                    <CustomModal user_id={user_id} setUserId={props.setUserId} showModal={showModal} handleClose={handleCloseModal}/>
                </div>
                <div className='col-md-6 mb-2'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="card">
                                <img className="card-img-top mb-2 about-img-top" src="../assets/images/fitness-2.jpg" alt="Card image cap" />
                                <div className="card-body card-body-about" style={{height:"90px"}}>
                                    <p className={`card-text ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{fontSize:"0.8em"}} >{t('about.card-1-desc')}</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="card">
                                <img className="card-img-top mb-2 about-img-top" src="../assets/images/health-3.jpg" alt="Card image cap" />
                                <div className="card-body card-body-about" style={{height:"90px"}}>
                                    <p className={`card-text ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{fontSize:"0.8em"}}>{t('about.card-2-desc')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
